import { useContext } from 'react';
import ReleaseNotesContext from 'src/contexts/ReleaseNotesContext';

const useReleaseNotes = () => useContext(ReleaseNotesContext);

export default useReleaseNotes;
